import { Button } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MapButton: FunctionComponent<Props> = ({
    children,
    className = '',
    onClick,
    testId = TEST_ID
}) => (
    <Button className={`${styles.mapButton} ${className}`} onClick={onClick} testId={testId}>
        {children}
    </Button>
);

export default MapButton;
